<div *nzModalTitle>
  <div class="modal-title">Удалить контакт?</div>
</div>
<div class="modal">
  <div class="modal__body">
    <p>Вся переписка с контактом “{{user}}” будет потеряна.</p>
    <div class="error" *ngIf="serverError && !isSuccess">
      {{serverError}}
    </div>
    <div class="success" *ngIf="isSuccess">
      <p>Контакт {{user}} успешно удален.</p>
    </div>
  </div>

  <div class="modal__footer">
    <ui-button *ngIf="!isSuccess" (click)="destroyModal()">{{cancelTextBtn}}</ui-button>
    <ui-button *ngIf="!isSuccess" (click)="submit()" >{{confirmTextBtn}}</ui-button>
    <ui-button *ngIf="isSuccess" (click)="confirmModal()">Понятно</ui-button>
  </div>
</div>
